import { Provider } from '@angular/core';
import { ANA_OPEN_PROFILE_PRICE } from 'components';
import { defer, map, Observable } from 'rxjs';
import { CreditPriceStateService } from './services/credit-price-state.service';
import { creditsPhrase } from './types/credit-statement.types';

// CONTRACT: the backend's SLIDER_REPORT action (app/billing/discovery_profile/actions.py) — charged once per slider OPEN, on a definitive result.
export const DISCOVERY_SLIDER_REPORT_ACTION_KEY =
	'profile_enrichment.slider_report';

/**
 * What the "Open profile" button in Ana's cards says opening the slider costs,
 * worded exactly as `app-action-price` words a fixed-price action. Null while
 * the action is absent from the price list — absent is not free.
 */
export function anaOpenProfilePrice(
	creditPriceState: CreditPriceStateService
): Observable<string | null> {
	return defer(() => {
		// The first button on screen pays for the one read, as every price control does.
		creditPriceState.ensureLoaded();
		return creditPriceState.snapshot$.pipe(
			map(() => {
				const price = creditPriceState.priceFor(
					DISCOVERY_SLIDER_REPORT_ACTION_KEY
				);
				if (!price) return null;
				return price.credits_milli === 0
					? 'Free'
					: creditsPhrase(price.credits_milli);
			})
		);
	});
}

export const ANA_OPEN_PROFILE_PRICE_PROVIDER: Provider = {
	provide: ANA_OPEN_PROFILE_PRICE,
	useFactory: anaOpenProfilePrice,
	deps: [CreditPriceStateService]
};
